<template>
  <div>
    <div class="row">
      <div class="input-field col s12 m6 l6 xl6">
        <input
		  readonly	 
          id="cpf"
          name="cpf"
          type="text"
          v-model='usu.cpf'/>
        <label for="cpf">CPF <small>(somente números)</small></label>
      </div>
      <div class="input-field col s6 m3 l3 xl3">
        <button v-if='this.edit' type="submit" class="btn">
          <i class="material-icons left">save</i>
          Salvar</button>
      </div>
    </div>
    <div class="row">
      <div class="input-field col s12 m6 l6 xl6">
        <input id="nome" name="nome" type="text" readonly v-model='usu.name'>
        <label for="nome">Nome </label>
      </div>
      <div class="input-field col s12 m6 l6 xl6">
        <input id="email" name="email" type="text" readonly v-model='usu.email'>
        <label for="email">E-mail</label>
      </div>
    </div>
	
	 <div class="row">
      <div class="input-field col s12 m6 l6 xl6">
        <input id="nome_social" name="nome_social" readonly type="text" v-model='usu.nome_social'>
		<label class='active' for="nome_social">Nome Social</label>
      </div>
	  <!--div class="input-field col s12 m6 l6 xl6">
        <input id="lattes" 
			name="lattes" 
			type="text" 
			class="validate" 
			:disabled ='!this.edit' 
			v-model='usu.lattes'
			maxlength="16"
			minlength="16"
			pattern="[0-9]+"
			v-bind:class="{ 'red-text': (usu.lattes && usu.lattes.length != 16), 'green-text': (usu.lattes && usu.lattes.length == 16) }"/>
        <label for="lattes">ID do Lattes</label>
      </div-->
	   <div v-if='!aluno' class="input-field col s12 m6 l6 xl6">
		<input id="cargo" name="cargo" type="text" readonly :value='cargo'>
        <label for="cargo">Cargo</label>
      </div>
    </div>
	
	<div v-if='aluno' class="row">
      <div class="input-field col s12 m6 l6 xl6">
        <input id="sira" name="sira" type="text" readonly v-model='aluno.sira'>
        <label for="sira">DRE</label>
      </div>
      <div class="input-field col s12 m6 l6 xl6">
        <input id="curso" name="curso" type="text" readonly v-model='aluno.curso'>
        <label for="curso">Curso</label>
      </div>
	 
	  </div>
    
	  <div class="row">
      <div class="input-field col s12 m6 l6 xl6">
		<label class='active' for="centro">Centro</label><br>
        <select name="centro" v-model="centroSelected" v-on:change="verifyUnidades" required class="browser-default select_sec" :disabled ='!this.edit'>
          <option value="" disabled selected>Escolha o centro</option>
          <option v-for="centro in this.cens" v-bind:value="centro.id" >{{centro.nome}}</option>
      </select>
    </div>
	  
      <div class="input-field col s12 m6 l6 xl6">
		<label class='active' for="unidade">Unidade</label><br>
        <select name="unidade" v-model="uniSelected" required class="browser-default select_sec" :disabled ='!this.edit'>
          <option value="" disabled selected>Escolha a unidade</option>
          <option v-for="unidade in this.unis" v-bind:value="unidade.id"  >{{unidade.nome}}</option>
        </select>
      </div>
    </div>
    
	<div v-if='!is_aluno' class="row">
      <div class="input-field col s12 m12 l12 xl12">
		<input v-if="loc.id" id="localizacao" name="localizacao" type="text" readonly v-model="loc.nome.trim() + '-' + loc.codigo">
		<input v-else id="localizacao" name="localizacao" type="text" readonly value=" ">
		<label class='active' for="localizacao">Localização</label><br>
      </div>
	</div>

	<div class="row" v-if="this.edit">
      <div class="input-field col s12 m6 l6 xl6">
		<select multiple id="permissoes[]" name="permissoes[]" class="validate" v-model='perfisUsu' @change="verificarPerfil()" >
		  <option v-for="(perfil, index) in perfisSis" v-if="isRoot == true || index > 1" :value="index"   >{{perfil[0]}}</option>
		</select>
        <label for="permissoes">Permissoes</label>
	  </div>
		<div class="input-field col s12 m6 l6 xl6">
			<label>
				<input type="checkbox" name='bloqueado' v-model='usu.bloqueado'/>
				<span>Bloqueado</span>
			</label>
		</div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "VueUsuariosForm",
      props: [
        'usuario',
        'edit',
        'root',
        'perfis',
        'constantes',
        'centros',
        'centro',
        'unidade',
		'bolsista',
		'localizacao',
		'is_aluno'
      ],
      data () {
        return {
          cens:JSON.parse(this.centros),
          usu: JSON.parse(this.usuario),
          isRoot: this.root,
          perfisUsu: JSON.parse(this.perfis),
          perfisSis: JSON.parse(this.constantes),
          info: '',
          cpfLength: false,
          cpfGuard: '',
          unis: null,
		  loc: JSON.parse(this.localizacao),
		  aluno: this.bolsista? JSON.parse(this.bolsista) : null,
          centroSelected:JSON.parse(this.centro).id,
          uniSelected:JSON.parse(this.unidade).id,
          cargo: '',
        }
      },
      methods: {

        verifyUnidades: function () {
          if (this.centroSelected) {
            this.$http.get('/api/centros/' + this.centroSelected + '/unidade').then((req) => {this.unis = req.body;})}
        },
        verificarPerfil: async function(){
          this.cens=await JSON.parse(this.centros);
		  this.cargo = '';
          //verifica  se o usuário tem o perfil de técnico.
          let isTecnico=false;
          for(let i =0;i < this.perfisUsu.length;i++){
            let perfil = this.perfisUsu[i];
            if(perfil == 16){
              isTecnico =true;
            }
			if (this.perfisSis[perfil][0] == 'Técnico' || this.perfisSis[perfil][0] == 'Docente')
			   this.cargo += this.perfisSis[perfil][0] + ',';
          }
          //se não tiver o perfil de técnico remover a administração central.
          if(!isTecnico){
            for(let i=0; i<this.cens.length; i++){
              let centro=this.cens[i];
              if(centro.id == 10 ){
                this.cens.splice(i,1);
                //this.uniSelected='';
              }
            }
          }
          this.verifyUnidades();
          this.cargo = this.cargo.slice(0, -1);
        },
      },
      
      mounted: function () {
        this.verificarPerfil();
		if (!this.centroSelected)
			this.centroSelected = '';
		if (!this.uniSelected)
			this.uniSelected = '';	
      },

    }

</script>
